(function () {
  'use strict';

  var root = document.getElementById('snd-root');
  var modal = document.getElementById('snd-modal');
  var ticket = document.getElementById('snd-ticket');
  var closeBtn = document.getElementById('snd-close');
  if (!root || !modal || !ticket) return;

  var CODE = root.dataset.code || 'Sondos';
  var delayMs = Math.max(0, Number(root.dataset.delay || 20) * 1000);
  var hideHours = Math.max(1, Number(root.dataset.hideHours || 1));
  var hideForMs = hideHours * 60 * 60 * 1000;
  var storageKey = 'sondos_promo_popup_welcome_' + String(CODE).toLowerCase();
  var opened = false;
  var delayTimer;
  var copyReset;

  var COPY_ICON = '<svg id="snd-ico" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var CHECK_ICON = '<svg id="snd-ico" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function getLastSeen() {
    try {
      return Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      return 0;
    }
  }

  function rememberSeen() {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // Private browsing can disable storage; the popup still remains usable.
    }
  }

  function shouldShow() {
    var lastSeen = getLastSeen();
    return !lastSeen || Date.now() - lastSeen >= hideForMs;
  }

  function removeTriggers() {
    window.clearTimeout(delayTimer);
  }

  function show() {
    if (opened || !shouldShow()) return;

    opened = true;
    rememberSeen();
    removeTriggers();
    modal.style.display = 'flex';
    void modal.offsetWidth;
    modal.classList.add('show');
  }

  function hide() {
    modal.classList.remove('show');
    rememberSeen();
    window.setTimeout(function () {
      modal.style.display = 'none';
      opened = false;
    }, 280);
  }

  function copy() {
    var lbl = document.getElementById('snd-tkt-label');
    var ico = document.getElementById('snd-ico');

    function done() {
      window.clearTimeout(copyReset);
      if (lbl) lbl.textContent = 'تم النسخ';
      if (ico) ico.outerHTML = CHECK_ICON;
      ticket.classList.add('done');
      copyReset = window.setTimeout(function () {
        if (lbl) lbl.textContent = 'كود الخصم';
        var i = document.getElementById('snd-ico');
        if (i) i.outerHTML = COPY_ICON;
        ticket.classList.remove('done');
      }, 1800);
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(CODE).then(done);
    } else {
      var t = document.createElement('textarea');
      t.value = CODE;
      t.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(t);
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);
      done();
    }
  }

  if (!shouldShow()) return;

  delayTimer = window.setTimeout(show, Math.max(0, delayMs - window.performance.now()));

  if (closeBtn) closeBtn.addEventListener('click', hide);
  ticket.addEventListener('click', copy);
  ticket.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      copy();
    }
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) hide();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('show')) hide();
  });
})();
